'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./css/loading.scss');

var _component = require('@loadable/component');

var _component2 = _interopRequireDefault(_component);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _language = require('../language');

var _Skeleton = require('../skeleton/Skeleton');

var _Skeleton2 = _interopRequireDefault(_Skeleton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function (_PureComponent) {
    (0, _inherits3.default)(Loading, _PureComponent);

    function Loading(props) {
        (0, _classCallCheck3.default)(this, Loading);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Loading.__proto__ || (0, _getPrototypeOf2.default)(Loading)).call(this, props));

        _this.state = {
            open: _lodash2.default.get(props, 'open', false)
        };
        _this.dataTestID = 'loading';
        return _this;
    }

    (0, _createClass3.default)(Loading, [{
        key: 'getDataTestId',
        value: function getDataTestId() {
            var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'component';

            return this.props.dataTestID || this.dataTestID + '-' + prefix;
        }
    }, {
        key: 'open',
        value: function open(text, className) {
            this.setState({
                open: true,
                text: text,
                className: className
            });
        }
    }, {
        key: 'close',
        value: function close() {
            this.setState({
                open: false
            });
        }
    }, {
        key: 'renderBody',
        value: function renderBody() {
            var _props = this.props,
                type = _props.type,
                className = _props.className;
            var text = this.state.text;


            if (type === 'skeleton') {
                return _react2.default.createElement(
                    'table',
                    { style: { width: '100%' } },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 35 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 35 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 35 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 35 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            ),
                            _react2.default.createElement(
                                'td',
                                { style: { textAlign: 'center', border: '1px solid #e9e9e9', padding: 7.5 } },
                                ' ',
                                _react2.default.createElement(
                                    'div',
                                    { style: {} },
                                    _react2.default.createElement(_Skeleton2.default.Input, { style: { width: 85 }, size: 'small', active: true, shape: 'cicle' })
                                )
                            )
                        )
                    )
                );
            }

            if (type === 'ellipsis') {
                return _react2.default.createElement(
                    'div',
                    (0, _extends3.default)({}, _lodash2.default.omit(this.props, ['text', 'className']), {
                        className: (0, _classnames2.default)("wrap-loading", className)
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'lds-ellipsis' },
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null),
                        _react2.default.createElement('div', null)
                    ),
                    text && _react2.default.createElement(
                        'div',
                        { style: {
                                textAlign: 'center',
                                color: '#222'
                            }
                        },
                        _react2.default.createElement(_language.TextTranslate, { text: text })
                    )
                );
            }
            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, _lodash2.default.omit(this.props, ['text', 'className']), {
                    className: (0, _classnames2.default)("wrap-loading", className, className)
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'lds-facebook' },
                    _react2.default.createElement('div', null),
                    _react2.default.createElement('div', null),
                    _react2.default.createElement('div', null)
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                top = _props2.top,
                opacity = _props2.opacity,
                right = _props2.right,
                left = _props2.left,
                bottom = _props2.bottom;
            var _state = this.state,
                className = _state.className,
                text = _state.text,
                open = _state.open;

            return _react2.default.createElement(
                'div',
                {
                    'data-testid': this.getDataTestId(),
                    className: (0, _classnames2.default)('idtek-loading', className, this.props.className, { "idtek-loading-visible": open }, { "idtek-loading-hidden": !open }),
                    style: {
                        position: 'absolute',
                        top: top || 0,
                        right: right || 0,
                        bottom: bottom || 0,
                        left: left || 0,
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: 'rgba(255, 255, 255, ' + (opacity || 1) + ')',
                        flexDirection: 'column',
                        zIndex: 99
                    }
                },
                this.props.children || this.renderBody(),
                text ? _react2.default.createElement(
                    'span',
                    null,
                    text
                ) : ''
            );
        }
    }]);
    return Loading;
}(_react.PureComponent);

exports.default = Loading;


Loading.defaultProps = {
    type: 'ellipsis'
};